import styled from "styled-components";

const Styles = styled.div`
  width: 90%;
  margin: 16px auto 64px;
`;

export default Styles;
